const timestamp = (file) => {
  const value = Date.parse(file?.createdAt || file?.updatedAt || "");
  return Number.isFinite(value) ? value : 0;
};

export const latestPaymentPlatformFile = (files = []) => (
  [...files]
    .filter((file) => file?.fileGCSKey)
    .sort((left, right) => timestamp(right) - timestamp(left))[0] || null
);

